import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const SubText = ({ classes, children }) => {
  return (
    <Typography display='inline'>
      <span className={classes.root}>{children}</span>
    </Typography>
  );
};

const styles = theme => ({
  root: {
    fontSize: '0.8rem',
    color: 'darkgray',
    fontWeight: 'normal'
  }
});

export default withStyles(styles)(SubText);
